// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__4ZyY1","footer":"ModalUpdate_footer__2NGx5"};